import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  fr: {
    // Navigation
    'nav.home': 'Accueil',
    'nav.catalog': 'Catalogue',
    'nav.usecases': 'Cas d\'usage',
    'nav.blog': 'Blog & Guides',
    'nav.contact': 'Contact',
    'nav.login': 'Connexion',
    'nav.register': 'Inscription',
    'nav.dashboard': 'Mon espace',
    'nav.admin': 'Administration',
    'nav.logout': 'Déconnexion',
    
    // Hero
    'hero.title': 'LogoTag® les produits publicitaires interactifs connectés !',
    'hero.subtitle.line1': 'Offrez un Objet Publicitaire Interactif qui marquera les esprits !',
    'hero.subtitle.line2': 'Transmettez en 1 seconde avec les produits de votre choix,',
    'hero.subtitle.line3': 'toutes les informations que vous souhaitez :',
    'hero.subtitle.line4': 'Contacts, Réseaux Sociaux, Catalogues, Vidéos, Site Web, Position Géographique dans un Salon, Applications, Promotions, Trajet vers le site de votre choix et tous Liens Utiles dont vous avez envie !',
    'hero.cta.quote': 'Demander un devis',
    'hero.cta.catalog': 'Voir le catalogue',
    
    // Categories
    'categories.title': 'Nos catégories de produits',
    'categories.viewAll': 'Voir tous les produits',
    
    // Products
    'products.requestQuote': 'Demander un devis',
    'products.requestSample': 'Commander un échantillon',
    'products.variants': 'Variantes',
    'products.nfcOptions': 'Options NFC',
    'products.printingOptions': 'Options d\'impression',
    'products.materials': 'Matériaux',
    'products.minQuantity': 'Quantité minimum',
    'products.indoor': 'Usage intérieur',
    'products.outdoor': 'Usage extérieur',
    'products.chipType': 'Type de puce',
    'products.capacity': 'Capacité',
    'products.compatibility': 'Compatibilité',
    'products.encoding': 'Encodage',
    'products.colors': 'couleurs',
    'products.customization': 'Personnalisation',
    'products.search': 'Rechercher un produit...',
    'products.filters': 'Filtres',
    'products.clearFilters': 'Effacer les filtres',
    'products.noResults': 'Aucun produit trouvé',
    'products.found': 'produit(s) trouvé(s)',
    'products.allProducts': 'Tous les produits',
    
    // Use Cases
    'usecases.title': 'Cas d\'usage métiers',
    'usecases.subtitle': 'Découvrez comment le NFC transforme votre secteur',
    'usecases.benefits': 'Avantages',
    'usecases.relatedProducts': 'Produits recommandés',
    
    // Quote
    'quote.title': 'Demande de devis',
    'quote.company': 'Entreprise',
    'quote.name': 'Nom / Prénom',
    'quote.email': 'Email',
    'quote.phone': 'Téléphone',
    'quote.sector': 'Secteur d\'activité',
    'quote.products': 'Produits sélectionnés',
    'quote.quantity': 'Quantité',
    'quote.message': 'Message / Besoins spécifiques',
    'quote.attachments': 'Fichiers joints',
    'quote.submit': 'Envoyer la demande',
    'quote.success': 'Votre demande a été envoyée avec succès',
    'quote.myQuotes': 'Mes demandes de devis',
    'quote.status.new': 'Nouveau',
    'quote.status.in_progress': 'En cours',
    'quote.status.sent': 'Devis envoyé',
    'quote.status.won': 'Gagné',
    'quote.status.lost': 'Perdu',
    
    // Sample
    'sample.title': 'Demande d\'échantillon',
    'sample.address': 'Adresse de livraison',
    'sample.submit': 'Commander l\'échantillon',
    'sample.success': 'Votre demande d\'échantillon a été envoyée',
    
    // Auth
    'auth.email': 'Email',
    'auth.password': 'Mot de passe',
    'auth.name': 'Nom complet',
    'auth.company': 'Entreprise',
    'auth.phone': 'Téléphone',
    'auth.login': 'Se connecter',
    'auth.register': 'S\'inscrire',
    'auth.googleLogin': 'Continuer avec Google',
    'auth.noAccount': 'Pas de compte ?',
    'auth.hasAccount': 'Déjà un compte ?',
    'auth.createAccount': 'Créer un compte',
    
    // FAQ
    'faq.title': 'Questions fréquentes',
    
    // Footer
    'footer.contact': 'Contact',
    'footer.legal': 'Mentions légales',
    'footer.cgv': 'CGV B2B',
    'footer.privacy': 'Politique de confidentialité',
    'footer.cookies': 'Politique cookies',
    'footer.tagline': 'Spécialiste des solutions NFC personnalisées pour professionnels',
    
    // Sectors
    'sector.hotel': 'Hôtellerie',
    'sector.restaurant': 'Restauration',
    'sector.real_estate': 'Immobilier',
    'sector.event': 'Événementiel',
    'sector.retail': 'Commerce',
    'sector.corporate': 'Entreprise',
    'sector.other': 'Autre',
    
    // Trust
    'trust.quality': 'Qualité premium',
    'trust.quality.desc': 'Produits certifiés et contrôlés',
    'trust.support': 'Accompagnement',
    'trust.support.desc': 'Conseil personnalisé',
    'trust.custom': 'Sur-mesure',
    'trust.custom.desc': 'Personnalisation complète',
    'trust.fast': 'Réactivité',
    'trust.fast.desc': 'Délais optimisés',
    
    // Common
    'common.loading': 'Chargement...',
    'common.error': 'Une erreur est survenue',
    'common.back': 'Retour',
    'common.next': 'Suivant',
    'common.save': 'Enregistrer',
    'common.cancel': 'Annuler',
    'common.delete': 'Supprimer',
    'common.edit': 'Modifier',
    'common.add': 'Ajouter',
    'common.upload': 'Télécharger',
    'common.required': 'Champ obligatoire',
    'common.discover': 'Découvrir',
    'common.viewAllCatalog': 'Voir tout le catalogue',
    'common.nfcProducts': 'produits NFC',
    'common.readyToStart': 'Prêt à démarrer votre projet NFC ?',
    'common.contactUs': 'Contactez-nous pour discuter de vos besoins et obtenir un devis personnalisé.',
  },
  en: {
    // Navigation
    'nav.home': 'Home',
    'nav.catalog': 'Catalog',
    'nav.usecases': 'Use Cases',
    'nav.blog': 'Blog & Guides',
    'nav.contact': 'Contact',
    'nav.login': 'Login',
    'nav.register': 'Sign up',
    'nav.dashboard': 'My Account',
    'nav.admin': 'Admin',
    'nav.logout': 'Logout',
    
    // Hero
    'hero.title': 'LogoTag® Interactive Connected Promotional Products!',
    'hero.subtitle.line1': 'Offer an Interactive Promotional Item that will leave a lasting impression!',
    'hero.subtitle.line2': 'Transmit in 1 second with the products of your choice,',
    'hero.subtitle.line3': 'all the information you want:',
    'hero.subtitle.line4': 'Contacts, Social Networks, Catalogs, Videos, Website, Geographic Location at Trade Shows, Apps, Promotions, Directions to your destination and all the Useful Links you need!',
    'hero.cta.quote': 'Request a quote',
    'hero.cta.catalog': 'View catalog',
    
    // Categories
    'categories.title': 'Our product categories',
    'categories.viewAll': 'View all products',
    
    // Products
    'products.requestQuote': 'Request a quote',
    'products.requestSample': 'Order a sample',
    'products.variants': 'Variants',
    'products.nfcOptions': 'NFC Options',
    'products.printingOptions': 'Printing Options',
    'products.materials': 'Materials',
    'products.minQuantity': 'Minimum quantity',
    'products.indoor': 'Indoor use',
    'products.outdoor': 'Outdoor use',
    'products.chipType': 'Chip type',
    'products.capacity': 'Capacity',
    'products.compatibility': 'Compatibility',
    'products.encoding': 'Encoding',
    'products.colors': 'colors',
    'products.customization': 'Customization',
    'products.search': 'Search products...',
    'products.filters': 'Filters',
    'products.clearFilters': 'Clear filters',
    'products.noResults': 'No products found',
    'products.found': 'product(s) found',
    'products.allProducts': 'All products',
    
    // Use Cases
    'usecases.title': 'Industry Use Cases',
    'usecases.subtitle': 'Discover how NFC transforms your industry',
    'usecases.benefits': 'Benefits',
    'usecases.relatedProducts': 'Recommended products',
    
    // Quote
    'quote.title': 'Quote Request',
    'quote.company': 'Company',
    'quote.name': 'Full Name',
    'quote.email': 'Email',
    'quote.phone': 'Phone',
    'quote.sector': 'Industry',
    'quote.products': 'Selected products',
    'quote.quantity': 'Quantity',
    'quote.message': 'Message / Specific needs',
    'quote.attachments': 'Attachments',
    'quote.submit': 'Submit request',
    'quote.success': 'Your request has been submitted successfully',
    'quote.myQuotes': 'My quote requests',
    'quote.status.new': 'New',
    'quote.status.in_progress': 'In Progress',
    'quote.status.sent': 'Quote Sent',
    'quote.status.won': 'Won',
    'quote.status.lost': 'Lost',
    
    // Sample
    'sample.title': 'Sample Request',
    'sample.address': 'Shipping address',
    'sample.submit': 'Order sample',
    'sample.success': 'Your sample request has been submitted',
    
    // Auth
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.name': 'Full name',
    'auth.company': 'Company',
    'auth.phone': 'Phone',
    'auth.login': 'Login',
    'auth.register': 'Sign up',
    'auth.googleLogin': 'Continue with Google',
    'auth.noAccount': 'No account?',
    'auth.hasAccount': 'Already have an account?',
    'auth.createAccount': 'Create account',
    
    // FAQ
    'faq.title': 'Frequently Asked Questions',
    
    // Footer
    'footer.contact': 'Contact',
    'footer.legal': 'Legal Notice',
    'footer.cgv': 'B2B Terms',
    'footer.privacy': 'Privacy Policy',
    'footer.cookies': 'Cookie Policy',
    'footer.tagline': 'Specialist in custom NFC solutions for professionals',
    
    // Sectors
    'sector.hotel': 'Hotels',
    'sector.restaurant': 'Restaurants',
    'sector.real_estate': 'Real Estate',
    'sector.event': 'Events',
    'sector.retail': 'Retail',
    'sector.corporate': 'Corporate',
    'sector.other': 'Other',
    
    // Trust
    'trust.quality': 'Premium quality',
    'trust.quality.desc': 'Certified and controlled products',
    'trust.support': 'Support',
    'trust.support.desc': 'Personalized advice',
    'trust.custom': 'Custom-made',
    'trust.custom.desc': 'Full customization',
    'trust.fast': 'Responsiveness',
    'trust.fast.desc': 'Optimized lead times',
    
    // Common
    'common.loading': 'Loading...',
    'common.error': 'An error occurred',
    'common.back': 'Back',
    'common.next': 'Next',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.add': 'Add',
    'common.upload': 'Upload',
    'common.required': 'Required field',
    'common.discover': 'Discover',
    'common.viewAllCatalog': 'View all catalog',
    'common.nfcProducts': 'NFC products',
    'common.readyToStart': 'Ready to start your NFC project?',
    'common.contactUs': 'Contact us to discuss your needs and get a personalized quote.',
  },
  ar: {
    // Navigation
    'nav.home': 'الرئيسية',
    'nav.catalog': 'الكتالوج',
    'nav.usecases': 'حالات الاستخدام',
    'nav.blog': 'المدونة والأدلة',
    'nav.contact': 'اتصل بنا',
    'nav.login': 'تسجيل الدخول',
    'nav.register': 'التسجيل',
    'nav.dashboard': 'حسابي',
    'nav.admin': 'الإدارة',
    'nav.logout': 'تسجيل الخروج',
    
    // Hero
    'hero.title': 'LogoTag® منتجات إعلانية تفاعلية متصلة!',
    'hero.subtitle.line1': 'قدّم منتجًا إعلانيًا تفاعليًا سيترك انطباعًا دائمًا!',
    'hero.subtitle.line2': 'انقل في ثانية واحدة مع المنتجات التي تختارها،',
    'hero.subtitle.line3': 'جميع المعلومات التي تريدها:',
    'hero.subtitle.line4': 'جهات الاتصال، الشبكات الاجتماعية، الكتالوجات، الفيديوهات، الموقع الإلكتروني، الموقع الجغرافي في المعارض، التطبيقات، العروض الترويجية، الاتجاهات إلى وجهتك وجميع الروابط المفيدة التي تحتاجها!',
    'hero.cta.quote': 'طلب عرض سعر',
    'hero.cta.catalog': 'عرض الكتالوج',
    
    // Categories
    'categories.title': 'فئات منتجاتنا',
    'categories.viewAll': 'عرض جميع المنتجات',
    
    // Products
    'products.requestQuote': 'طلب عرض سعر',
    'products.requestSample': 'طلب عينة',
    'products.variants': 'المتغيرات',
    'products.nfcOptions': 'خيارات NFC',
    'products.printingOptions': 'خيارات الطباعة',
    'products.materials': 'المواد',
    'products.minQuantity': 'الحد الأدنى للكمية',
    'products.indoor': 'للاستخدام الداخلي',
    'products.outdoor': 'للاستخدام الخارجي',
    'products.chipType': 'نوع الشريحة',
    'products.capacity': 'السعة',
    'products.compatibility': 'التوافق',
    'products.encoding': 'الترميز',
    'products.colors': 'ألوان',
    'products.customization': 'التخصيص',
    'products.search': 'البحث عن منتج...',
    'products.filters': 'الفلاتر',
    'products.clearFilters': 'مسح الفلاتر',
    'products.noResults': 'لم يتم العثور على منتجات',
    'products.found': 'منتج(ات) موجودة',
    'products.allProducts': 'جميع المنتجات',
    
    // Use Cases
    'usecases.title': 'حالات الاستخدام المهنية',
    'usecases.subtitle': 'اكتشف كيف يحول NFC قطاعك',
    'usecases.benefits': 'المزايا',
    'usecases.relatedProducts': 'المنتجات الموصى بها',
    
    // Quote
    'quote.title': 'طلب عرض سعر',
    'quote.company': 'الشركة',
    'quote.name': 'الاسم الكامل',
    'quote.email': 'البريد الإلكتروني',
    'quote.phone': 'الهاتف',
    'quote.sector': 'القطاع',
    'quote.products': 'المنتجات المختارة',
    'quote.quantity': 'الكمية',
    'quote.message': 'الرسالة / الاحتياجات الخاصة',
    'quote.attachments': 'المرفقات',
    'quote.submit': 'إرسال الطلب',
    'quote.success': 'تم إرسال طلبك بنجاح',
    'quote.myQuotes': 'طلبات عروض الأسعار الخاصة بي',
    'quote.status.new': 'جديد',
    'quote.status.in_progress': 'قيد التنفيذ',
    'quote.status.sent': 'تم إرسال العرض',
    'quote.status.won': 'مكتسب',
    'quote.status.lost': 'مفقود',
    
    // Sample
    'sample.title': 'طلب عينة',
    'sample.address': 'عنوان التسليم',
    'sample.submit': 'طلب العينة',
    'sample.success': 'تم إرسال طلب العينة الخاص بك',
    
    // Auth
    'auth.email': 'البريد الإلكتروني',
    'auth.password': 'كلمة المرور',
    'auth.name': 'الاسم الكامل',
    'auth.company': 'الشركة',
    'auth.phone': 'الهاتف',
    'auth.login': 'تسجيل الدخول',
    'auth.register': 'التسجيل',
    'auth.googleLogin': 'المتابعة مع Google',
    'auth.noAccount': 'ليس لديك حساب؟',
    'auth.hasAccount': 'لديك حساب بالفعل؟',
    'auth.createAccount': 'إنشاء حساب',
    
    // FAQ
    'faq.title': 'الأسئلة الشائعة',
    
    // Footer
    'footer.contact': 'اتصل بنا',
    'footer.legal': 'الإشعار القانوني',
    'footer.cgv': 'شروط B2B',
    'footer.privacy': 'سياسة الخصوصية',
    'footer.cookies': 'سياسة ملفات تعريف الارتباط',
    'footer.tagline': 'متخصصون في حلول NFC المخصصة للمحترفين',
    
    // Sectors
    'sector.hotel': 'الفنادق',
    'sector.restaurant': 'المطاعم',
    'sector.real_estate': 'العقارات',
    'sector.event': 'الفعاليات',
    'sector.retail': 'التجزئة',
    'sector.corporate': 'الشركات',
    'sector.other': 'أخرى',
    
    // Trust
    'trust.quality': 'جودة ممتازة',
    'trust.quality.desc': 'منتجات معتمدة ومراقبة',
    'trust.support': 'الدعم',
    'trust.support.desc': 'استشارة شخصية',
    'trust.custom': 'مخصص',
    'trust.custom.desc': 'تخصيص كامل',
    'trust.fast': 'الاستجابة السريعة',
    'trust.fast.desc': 'مواعيد تسليم محسنة',
    
    // Common
    'common.loading': 'جاري التحميل...',
    'common.error': 'حدث خطأ',
    'common.back': 'رجوع',
    'common.next': 'التالي',
    'common.save': 'حفظ',
    'common.cancel': 'إلغاء',
    'common.delete': 'حذف',
    'common.edit': 'تعديل',
    'common.add': 'إضافة',
    'common.upload': 'تحميل',
    'common.required': 'حقل مطلوب',
    'common.discover': 'اكتشف',
    'common.viewAllCatalog': 'عرض الكتالوج كاملاً',
    'common.nfcProducts': 'منتجات NFC',
    'common.readyToStart': 'هل أنت مستعد لبدء مشروع NFC الخاص بك؟',
    'common.contactUs': 'اتصل بنا لمناقشة احتياجاتك والحصول على عرض سعر مخصص.',
  }
};

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('language');
    return saved || 'fr';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.lang = language;
    // Set RTL direction for Arabic
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['fr']?.[key] || key;
  };

  const cycleLanguage = () => {
    setLanguage(prev => {
      if (prev === 'fr') return 'en';
      if (prev === 'en') return 'ar';
      return 'fr';
    });
  };

  const languages = [
    { code: 'fr', name: 'Français', flag: '🇫🇷' },
    { code: 'en', name: 'English', flag: '🇬🇧' },
    { code: 'ar', name: 'العربية', flag: '🇸🇦' }
  ];

  return (
    <LanguageContext.Provider value={{ language, setLanguage, cycleLanguage, languages, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}

export default LanguageContext;
